import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import PropTypes from "prop-types";
import DropDown, { DropDownItem } from "MODULES/shared/components/DropDown";
import { toastr } from "react-redux-toastr";
import { ConfirmAction, Icon } from "MODULES/shared/components";
import {
  cancelRequestVendorRma,
  cancelROLineItem,
  deleteExpectedComponent
} from "MODULES/RepairOrders/actions";
import { EXPECTED_COMPONENT } from "MODULES/RepairOrders/constants";
import Transfer from "MODULES/RepairOrders/components/Detail/LineItems/LineItemControls/Transfer/Transfer";
import TransferModal from "MODULES/RepairOrders/components/Detail/LineItems/LineItemControls/Transfer/TransferModal";
import ReturnRepairItem from "MODULES/RepairOrders/components/Detail/LineItems/LineItemControls/ReturnRepairItem/ReturnRepairItem";
import ReturnRepairItemModal from "MODULES/RepairOrders/components/Detail/LineItems/LineItemControls/ReturnRepairItem/ReturnRepairItemModal";
import RequiredComponentModal from "MODULES/RepairOrders/components/Detail/LineItems/LineItemControls/RequiredComponents/RequiredComponentModal";
import RequiredComponent from "MODULES/RepairOrders/components/Detail/LineItems/LineItemControls/RequiredComponents/RequiredComponent";
import withRepairOrder from "MODULES/RepairOrders/decorators/withRepairOrder";
import RemoveMainComponent from "MODULES/RepairOrders/components/Detail/LineItems/LineItemControls/RemoveMainComponent/RemoveMainComponent";
import RequestVendorRmaModal from "MODULES/RepairOrders/components/Detail/LineItems/LineItemControls/RequestVendorRma/RequestVendorRmaModal";
import { ConfirmModal, Cancel } from "./Cancel";
import RequestVendorRma from "./RequestVendorRma/RequestVendorRma";
import CancelRmaVendorRequest from "./CancelRmaVendorRequest/CancelRmaVendorRequest";

export class LineItemControls extends React.Component {
  state = {
    cancelRequestModalOpen: false,
    confirmOpen: false,
    approvalModalOpen: false,
    requestModalOpen: false,
    requiredComponentModalOpen: false,
    transferModalOpen: false,
    deleteExpectedComponentModalOpen: false,
    reason: "previously_sold"
  };

  updateReason = reason => this.setState({ reason });

  toggleModal = type => this.setState({ [type]: !this.state[type] });

  handleCancel = () =>
    this.props
      .cancel(this.props.lineItem.id, this.state.reason)
      .then(this.toggleModal("confirmOpen"));

  cancelVendorRmaRequest = () =>
    this.props
      .cancelRequestVendorRma(this.props.lineItem.id)
      .then(this.toggleModal("cancelRequestModalOpen"))
      .then(() => {
        toastr.success("Success", "Vendor RMA Request Cancelled");
      });

  cancelExpectedComponent = () =>
    this.props
      .deleteExpectedComponent(this.props.lineItem.id)
      .then(this.toggleModal("deleteExpectedComponentModalOpen"))
      .then(() => {
        toastr.success("Success", "Removed Expected Component");
      });

  render() {
    const {
      cancelRequestModalOpen,
      confirmOpen,
      deleteExpectedComponentModalOpen,
      requestModalOpen,
      requiredComponentModalOpen,
      transferModalOpen
    } = this.state;
    const { lineItem, returnItemModalOpen, toggleReturnModal } = this.props;

    const displayCancel =
      lineItem.cancellable && lineItem.action_requested !== EXPECTED_COMPONENT;

    const canCancelExpectedComponent =
      lineItem.action_requested === EXPECTED_COMPONENT &&
      lineItem.quantity_received === 0;

    return (
      <div>
        <DropDown icon="fa fa-fw fa-ellipsis-v" menuClass="dropdown-menu-right">
          {displayCancel && (
            <Cancel toggle={() => this.toggleModal("confirmOpen")} />
          )}
          <RemoveMainComponent lineItem={lineItem} />
          <ReturnRepairItem
            toggleReturnModal={toggleReturnModal}
            lineItem={lineItem}
          />
          <RequestVendorRma
            toggleRequestModal={() => this.toggleModal("requestModalOpen")}
            lineItem={lineItem}
          />

          <CancelRmaVendorRequest
            toggleRequestModal={() =>
              this.toggleModal("cancelRequestModalOpen")}
            lineItem={lineItem}
          />
          <Transfer
            lineItem={lineItem}
            open={transferModalOpen}
            toggleRequestModal={() => this.toggleModal("transferModalOpen")}
          />
          {canCancelExpectedComponent && (
            <DropDownItem
              onClick={() =>
                this.toggleModal("deleteExpectedComponentModalOpen")}
            >
              <Icon name="ban" fixed />
              Remove Expected Component
            </DropDownItem>
          )}
          <RequiredComponent
            lineItem={lineItem}
            toggleComponentModal={() =>
              this.toggleModal("requiredComponentModalOpen")}
          />
        </DropDown>
        <ConfirmModal
          onConfirm={this.handleCancel}
          updateReason={this.updateReason}
          open={confirmOpen}
          close={() => this.toggleModal("confirmOpen")}
        />
        <TransferModal
          close={() => this.toggleModal("transferModalOpen")}
          open={transferModalOpen}
          lineItem={lineItem}
        />
        <RequestVendorRmaModal
          lineItem={lineItem}
          open={requestModalOpen}
          close={() => this.toggleModal("requestModalOpen")}
        />
        <RequiredComponentModal
          lineItem={lineItem}
          repairOrder={this.props.repairOrder}
          open={requiredComponentModalOpen}
          close={() => this.toggleModal("requiredComponentModalOpen")}
        />
        <ReturnRepairItemModal
          lineItem={lineItem}
          open={returnItemModalOpen === lineItem.id}
          close={toggleReturnModal}
        />
        <ConfirmAction
          open={cancelRequestModalOpen}
          close={() => this.toggleModal("cancelRequestModalOpen")}
          onConfirm={this.cancelVendorRmaRequest}
        >
          <strong>Heads up!</strong>
          <p>Are you sure you want to cancel this Vendor RMA request?</p>
        </ConfirmAction>
        <ConfirmAction
          open={deleteExpectedComponentModalOpen}
          close={() => this.toggleModal("deleteExpectedComponentModalOpen")}
          onConfirm={this.cancelExpectedComponent}
        />
      </div>
    );
  }
}

LineItemControls.propTypes = {
  lineItem: PropTypes.shape({
    cancelled: PropTypes.bool.isRequired,
    final_evaluation_approved: PropTypes.bool,
    id: PropTypes.number.isRequired
  }),
  cancel: PropTypes.func.isRequired,
  cancelRequestVendorRma: PropTypes.func.isRequired,
  deleteExpectedComponent: PropTypes.func.isRequired,
  returnItemModalOpen: PropTypes.bool.isRequired,
  toggleReturnModal: PropTypes.func.isRequired
};

export default connect(undefined, dispatch => ({
  cancel: (id, reason) => dispatch(cancelROLineItem(id, reason)),
  cancelRequestVendorRma: id => dispatch(cancelRequestVendorRma(id)),
  deleteExpectedComponent: id => dispatch(deleteExpectedComponent(id))
}))(withRepairOrder(LineItemControls));



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/LineItemControls/LineItemControls.jsx